import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import { post } from '../Services/http';
import { catchError } from './Error.action';

export const QUICK_SEARCH_QUERY = 'QUICK_SEARCH_QUERY';
export const QUICK_SEARCH_RECEIVE = 'QUICK_SEARCH_RECEIVE';
export const QUICK_SEARCH_ERROR = 'QUICK_SEARCH_ERROR';
export const QUICK_SEARCH_SHOW_FULL_FORM = 'QUICK_SEARCH_SHOW_FULL_FORM';
export const QUICK_SEARCH_SELECT_ITEM = 'QUICK_SEARCH_SELECT_ITEM';
export const QUICK_SEARCH_RESULT_MOBILE = 'QUICK_SEARCH_RESULT_MOBILE';
export const QUICK_SEARCH_RESULT_DESKTOP = 'QUICK_SEARCH_RESULT_DESKTOP';
export const QUICK_SEARCH_IS_MOBILE = 'QUICK_SEARCH_IS_MOBILE';
export const QUICK_SEARCH_RECEIVE_PRICES = 'QUICK_SEARCH_RECEIVE_PRICES';

let abortController;

export const receive = result => ({
    type: QUICK_SEARCH_RECEIVE,
    payload: {
        result,
        showResult: result.hasResultsGroup,
    },
});

export const receiveMobile = resultMobile => ({
    type: QUICK_SEARCH_RESULT_MOBILE,
    payload: {
        resultMobile,
    },
});

export const receiveDesktop = resultDesktop => ({
    type: QUICK_SEARCH_RESULT_DESKTOP,
    payload: {
        resultDesktop,
    },
});

export const setOnMobile = isMobile => ({
    type: QUICK_SEARCH_IS_MOBILE,
    payload: {
        isMobile,
    },
});

export const searchError = error => ({
    type: QUICK_SEARCH_ERROR,
    payload: {
        error,
    },
});

const selectItem = selectedItem => ({
    type: QUICK_SEARCH_SELECT_ITEM,
    payload: {
        selectedItem,
    },
});

const show = visible => ({
    type: QUICK_SEARCH_SHOW_FULL_FORM,
    payload: {
        showFullForm: visible,
    },
});

export const receivePrices = data => ({
    type: QUICK_SEARCH_RECEIVE_PRICES,
    payload: {
        priceList: data,
    },
});

export const query = q => dispatch => {
    // Abort any existing, pending request.
    // It's ok to call .abort() after the fetch has already completed, fetch simply ignores it.
    abortController && abortController.abort();
    abortController = new AbortController();
    const contentLinksArray =
        window.__litium.preloadState.navigation.contentLinks;
    const contentLinkObj =
        contentLinksArray && contentLinksArray.find(obj => obj.isSelected);
    const systemId = contentLinkObj ? contentLinkObj.systemId : '';
    const payload = {
        Query: q,
        PageSystemId: systemId,
    };

    if (decodeURIComponent(q).length >= 3) {
        return post('/api/quickSearch', payload, abortController)
            .then(response => response.json())
            .then(result => {
                dispatch(receive(result));

                if (!result.resultGroups) {
                    return;
                }

                let mobileData = [];
                let desktopData = [];
                for (let i = 0; i < result.resultGroups.length; i++) {
                    mobileData = [
                        ...mobileData,
                        ...result.resultGroups[i].results.slice(
                            0,
                            result.resultGroups[i].numberToViewMobile
                        ),
                    ];
                    desktopData = [
                        ...desktopData,
                        ...result.resultGroups[i].results.slice(
                            0,
                            result.resultGroups[i].numberToViewDesktop
                        ),
                    ];
                }
                dispatch(receiveMobile(mobileData));
                dispatch(receiveDesktop(desktopData));
            })
            .catch(ex => dispatch(catchError(ex, error => searchError(error))));
    }
};

export const checkWindowWidth = () => dispatch => {
    let windowWidth = window.innerWidth < 1200;
    dispatch(setOnMobile(windowWidth));
};

export const setSearchQuery = query => ({
    type: QUICK_SEARCH_QUERY,
    payload: {
        query,
    },
});

export const toggleShowFullForm = () => (dispatch, getState) => {
    dispatch(show(!getState().quickSearch.showFullForm));
};

export const handleKeyDown = (event, opt) => (dispatch, getState) => {
    const {
        result,
        resultMobile,
        resultDesktop,
        isMobile,
        selectedItem,
    } = getState().quickSearch;
    const q = event.target.value;
    const resultIsEmpty =
        result.hasOwnProperty('resultGroups') && result.resultGroups !== null;
    const resultList = isMobile ? resultMobile : resultDesktop;
    const max = resultList?.length - 1,
        clip = index => (index < 0 ? max : index > max ? 0 : index);

    switch (event.keyCode) {
        case 38:
            if (!resultIsEmpty) {
                return;
            }
            dispatch(selectItem(clip(selectedItem - 1)));
            break;
        case 40:
            if (!resultIsEmpty) {
                return;
            }
            dispatch(selectItem(clip(selectedItem + 1)));
            break;
        case 13:
            if (decodeURIComponent(q).length >= 3) {
                const selectedObject = resultList[selectedItem];
                if (selectedObject && selectedObject.url && resultIsEmpty) {
                    location.href = selectedObject.url;
                } else {
                    location.href = opt.searchUrl;
                }
            }
            break;
        default:
            break;
    }
};

export const onIconSearch = (event, opt) => (dispatch, getState) => {
    const { result, selectedItem, query } = getState().quickSearch,
        selectedObject = result[selectedItem];

    if (decodeURIComponent(query).length >= 3) {
        if (selectedObject && selectedObject.url) {
            location.href = selectedObject.url;
        } else {
            location.href = opt.searchUrl;
        }
    }
};